// extracted by mini-css-extract-plugin
export var disabled = "_2v-5";
export var fileName = "_2v-b";
export var filePreview = "_2v-4";
export var hoverFilter = "_2v-6";
export var imageButton = "_2v-3 _2v-6";
export var imageButtonContainer = "_2v-2";
export var input = "_2v-7";
export var removeButton = "_2v-0";
export var removeButtonFile = "_2v-1";
export var spinner = "_2v-9";
export var spinnerContainer = "_2v-8";
export var videoContainer = "_2v-a _2v-6";